export default __webpack_public_path__ + "static/media/jim_black.8d46501d.jpg";